import { Injectable } from '@angular/core';
import { QueryEntity } from '@examdojo/state';
import { StudentClassAssignmentStoreModel } from './student-class-assignment.model';
import { StudentClassAssignmentState, StudentClassAssignmentStore } from './student-class-assignment.store';

function getTodoPriority(e: StudentClassAssignmentStoreModel): number {
  if (e.homework_status === 'IN_PROGRESS' || e.homework_status === 'PAUSED') {
    return 0;
  }
  if (e.due_at && new Date(e.due_at) < new Date()) {
    return 1;
  }
  return 2;
}

function compareDueAtAsc(a: string | null, b: string | null): number {
  if (!a && !b) {
    return 0;
  }
  if (!a) {
    return 1;
  }
  if (!b) {
    return -1;
  }
  return new Date(a).getTime() - new Date(b).getTime();
}

@Injectable({ providedIn: 'root' })
export class StudentClassAssignmentQuery extends QueryEntity<
  StudentClassAssignmentState,
  StudentClassAssignmentStoreModel,
  StudentClassAssignmentStoreModel,
  'assignment_id'
> {
  constructor(protected override readonly store: StudentClassAssignmentStore) {
    super(store);
  }

  getTodoByClassId(classId: string): StudentClassAssignmentStoreModel[] {
    return this.getEntitiesByPredicate((e) => e.class_id === classId && e.homework_status !== 'COMPLETED').sort(
      (a, b) => {
        const priorityDiff = getTodoPriority(a) - getTodoPriority(b);
        if (priorityDiff !== 0) {
          return priorityDiff;
        }
        return compareDueAtAsc(a.due_at, b.due_at);
      },
    );
  }

  getDoneByClassId(classId: string): StudentClassAssignmentStoreModel[] {
    return this.getEntitiesByPredicate((e) => e.class_id === classId && e.homework_status === 'COMPLETED').sort(
      (a, b) => new Date(b.homework_updated_at ?? 0).getTime() - new Date(a.homework_updated_at ?? 0).getTime(),
    );
  }
}
